import { PageToolbar } from '@app/components/page-toolbar/PageToolbar';
import { LinkItem, NavLinksMUI } from '@mi-front/ui';
import { Box } from '@mui/material';
import { PageActions } from './PageActions';
import { PageTitle } from './PageTitle';
import { PageTabsSkeleton } from './skeleton/PageTabsSkeleton';

interface Props {
  icon?: React.ReactNode;
  title?: React.ReactNode | React.ReactNode[];
  actions?: React.ReactNode;
  breadcrumbs?: React.ReactNode;
  backBtn?: boolean | string;
  tabs?: readonly LinkItem[];
  isLoading?: boolean;
  children?: React.ReactNode;
}

export function PageHeader({
  icon,
  title,
  actions,
  breadcrumbs,
  backBtn,
  tabs,
  isLoading,
  children,
}: Props) {
  return (
    <PageToolbar
      id="page-header"
      sx={{
        pb: tabs || children ? 0 : 1.25,
      }}
    >
      {breadcrumbs}
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mt={breadcrumbs ? 1 : 0}
        height="40px"
      >
        <PageTitle icon={icon} title={title} backBtn={backBtn} />
        <PageActions actions={actions} />
      </Box>

      {!!tabs && (
        <Box mt={1}>
          {isLoading ? <PageTabsSkeleton count={tabs.length} /> : <NavLinksMUI links={tabs} />}
        </Box>
      )}

      {children}
    </PageToolbar>
  );
}
